import {AfterViewInit, Directive, ElementRef, Inject, Input, OnChanges, Renderer2, SimpleChanges} from '@angular/core';

@Directive({
  standalone: false,
  selector: '[appHighlightText]'
})
export class HighlightTextDirective implements OnChanges, AfterViewInit {
  @Input() appHighlightText!: string;

  constructor(@Inject(ElementRef) private el: ElementRef, @Inject(Renderer2) private renderer: Renderer2) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appHighlightText']) {
      this.updateHighlight();
    }
  }

  ngAfterViewInit(): void {
    this.updateHighlight();
  }

  private updateHighlight(): void {
    const textContent = this.el.nativeElement.textContent || '';
    const match = this.appHighlightText &&
      textContent.toLowerCase().includes(this.appHighlightText.toLowerCase());
    if (match) {
      this.renderer.addClass(this.el.nativeElement, 'highlight');
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'highlight');
    }
  }
}
